import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import ContractDeliverable from "./ContractDeliverable";
import moment from 'moment';

require('moment/locale/el');

export default class ContractDeliverables extends Component {
    constructor() {
        super();

        this.state = {
            items: [],
            next_key: 0,
        };

        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    componentWillMount() {
        let items = (this.props.items !== null ? this.props.items : []);

        let key = 1;
        for (let item_key in items) {
            if (items.hasOwnProperty(item_key)) {
                items[item_key].key = key;
                key++;
            }
        }

        this.setState({
            items: items,
            next_key: key + 1
        });
    }

    addItem() {
        let items = this.state.items;
        let key = this.state.next_key;
        items.push({
            key: key,
            title: "",
            deadline_formatted: moment()
        });
        key++;
        this.setState({
            items: items,
            next_key: key
        });
    }

    removeItem(key) {
        let items = this.state.items;
        items = items.filter((item) => item.key !== key);
        this.setState({items: items});
    }

    render() {
        let items = this.state.items;
        let rows = [];
        if (items.length > 0) {
            for (let item_index in items) {
                if (items.hasOwnProperty(item_index)) {
                    let row = items[item_index];
                    rows.push(
                        <ContractDeliverable key={row.key}
                                             item={row}
                                             removeFn={this.removeItem}/>
                    );
                }
            }
        } else {
            rows.push(
                <tr key="0">
                    <td colSpan="4">
                        <em dangerouslySetInnerHTML={{__html: window.__js_contracts.no_deliverables_add_msg}}></em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-sm-offset-4 col-sm-8">
                        <legend>{window.__js_contracts.deliverables_table}</legend>
                    </div>
                </div>
                <Button onClick={this.addItem}
                        bsStyle="primary">
                    <i className="fa fa-plus"></i> {window.__js_contracts.add_deliverable}
                </Button>
                <div className="table-responsive" style={{minHeight: 500}}>
                    <table className="table table-hover table-bordered table-striped">
                        <thead>
                        <tr>
                            <th>{window.__js_contracts.deliverable_name}*</th>
                            <th>{window.__js_contracts.deliverable_date}*</th>
                            <th>{window.__js_contracts.attached_file}</th>
                            <th>{window.__js_contracts.actions}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}